import api from './apiClient'

/**
 * `GET /process-flows` devolve o array de fluxos já com as etapas aninhadas —
 * não há rota de etapa isolada. Cor, obrigatoriedade, próxima etapa e
 * permissões não existem no schema legado e voltam como `null`.
 */
const listarFluxos = async subCompanyId => {
  const response = await api.get('/process-flows', { params: { subCompanyId } })
  return Array.isArray(response.data) ? response.data : []
}

// -------------------------------------------------------- Fluxo (Processo) --

export const getProcess = async data => {
  const fluxos = await listarFluxos(data.subCompanyId)
  return { data: { result: fluxos, total: fluxos.length } }
}

export const getProcessId = async (processId, subCompanyId) => {
  const fluxos = await listarFluxos(subCompanyId)
  return { data: fluxos.find(fluxo => fluxo.id === processId) || null }
}

export const createProcess = async data => api.post('/process-flows', data)

export const editProcess = async data => {
  const { processId, ...corpo } = data
  return api.patch(`/process-flows/${processId}`, corpo)
}

export const deleteProcess = async processId => api.delete(`/process-flows/${processId}`)

// ------------------------------------------------- Etapas (ProcessSequence) --

/** Etapas de um fluxo específico. */
export const getProcessSequenceAllList = async data => {
  const fluxos = await listarFluxos(data.subCompanyId)
  const fluxo = fluxos.find(item => item.id === data.processId)
  return { data: (fluxo && fluxo.stages) || [] }
}

/** Todas as etapas da filial, achatadas — base das colunas do Kanban. */
export const getProcessSequence = async data => {
  const fluxos = await listarFluxos(data.subCompanyId)
  const etapas = fluxos.flatMap(fluxo => fluxo.stages || [])
  return { data: { result: etapas, total: etapas.length } }
}

export const createProcessSequence = async data => {
  const { processId, ...corpo } = data
  return api.post(`/process-flows/${processId}/stages`, corpo)
}

export const editProcessSequence = async data => {
  const { processId, processSequenceId, ...corpo } = data
  return api.patch(`/process-flows/${processId}/stages/${processSequenceId}`, corpo)
}

export const deleteProcessSequence = async (processId, processSequenceId) =>
  api.delete(`/process-flows/${processId}/stages/${processSequenceId}`)

/** `PUT /process-flows/{id}/stages/reorder` — reordenação em uma chamada só. */
export const reorderProcessSequence = async (processId, stageIds) =>
  api.put(`/process-flows/${processId}/stages/reorder`, { stageIds })
